import axios from '@/lib/axios';
import { FixedAsset, Product, PurchaseOrder } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0560. 発注案件アーカイブ
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:id/archive
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const archivePurchaseOrder = (props: Props): Promise<PurchaseOrder> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/archive`, props);
};

export const useArchivePurchaseOrder = () => {
  return useMutation({
    mutationFn: archivePurchaseOrder,
  });
};
